import { PriceRequestService } from './../../../../api/priceRequest.service';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { AppGetQuoteNoteComponent } from './app-get-quote-note/app-get-quote-note.component';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import * as _moment from 'moment';
import { UtilService } from '@app/services/util.service';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
const moment = _moment;
@Component({
  selector: 'meu-app-get-quote-list',
  templateUrl: './app-get-quote-list.component.html',
  styleUrls: ['./app-get-quote-list.component.scss'],
})
export class AppGetQuoteListComponent implements OnInit {
  constructor(
    private priceRequestService: PriceRequestService,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog,
    private toastService: ToastrService,
    private http: HttpClient
  ) {}
  search: any = '';
  displayedColumns: any = [
    'extend_user_full_name',
    'extend_user_phone',
    'extend_product_name',
    'created_at',
    'action',
  ];
  displayedRows: any = [];
  totalRequest: any;
  pagesize: any = 10;
  pageIndex: any = 1;
  lstAllRequest: any;
  lstAllRequestSort: any;
  loading: boolean = false;
  status: any = 'all';
  public keyUp = new Subject<KeyboardEvent>();

  // THÊM DÒNG NÀY
  pageSizeOptions: number[] = [5, 10, 20, 100];

  ngOnInit() {
    this.getAllRequestPrice();
  }
  ngOnDestroy() {
    this.ref.detach();
  }
  appoveRequest(element, boolean) {
    element.proceed = boolean;
    this.priceRequestService.apiPriceRequestsIdPut(element.id, element).subscribe((res) => {
      if (res.success) {
        element = res.data;
        this.toastService.success('Đã xử lý thành công', '');
      }
    });
  }
  focusSelectStatus() {
    const element = document.getElementById('sortStatus');
    setTimeout(() => {
      element.blur();
    }, 200);
  }
  displayStatus(value) {
    switch (value) {
      case 'all':
        return 'Tất cả';
        break;
      case 'processed':
        return 'Đã xử lý';
        break;
      case 'noprocess':
        return 'Chưa xử lý';
        break;
    }
  }
  getAllRequestPrice() {
    let filter = '';
    if (this.search != '') {
      filter =
        'extend_product_name|extend_user_full_name|extend_user_phone @=*' + this.search + ',';
    }
    if (this.status === 'processed') {
      filter += 'proceed==true';
    }
    if (this.status === 'noprocess') {
      filter += 'proceed!=true';
    }

    this.priceRequestService
      .apiPriceRequestsFastDataGet(filter, '', this.pageIndex, this.pagesize)
      .subscribe((res) => {
        if (res.success) {
          this.lstAllRequest = res.data.collection;
          this.lstAllRequest.forEach((item) => {
            item.seo_name = UtilService.slugify(item.extend_product_name);
          });
          this.lstAllRequestSort = [...this.lstAllRequest];
          // this.pageIndex = res.data.pageIndex; // Tắt dòng này
          // this.pagesize = res.data.pagesize; // Tắt dòng này
          this.totalRequest = res.data.total;
          this.ref.detectChanges();
        }
      });
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAllRequestPrice();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pagesize = newSize;
    this.pageIndex = 1;
    this.getAllRequestPrice();
  }

  moment(date) {
    return moment(date).format('DD-MM-YYYY hh:mm');
  }
  openModalNote(item) {
    var _this = this;
    const dialogRef = this.dialog.open(AppGetQuoteNoteComponent, {
      data: {
        quote: item,
      },
      width: '700px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.event) {
        item = result.item;
      }
      // this.getData();
    });
  }

  private triggerDownload(url: string, fallbackFilename: string) {
    this.http.get(url, { responseType: 'blob', observe: 'response' }).subscribe(
      (response: any) => {
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const res = JSON.parse(reader.result as string);
              this.toastService.error(res.message || 'Không thể tải file.');
            } catch (e) {
              this.toastService.error('Không thể tải file.');
            }
          };
          reader.readAsText(response.body);
          return;
        }

        let filename = fallbackFilename;
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
          const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (utf8Match) {
            filename = decodeURIComponent(utf8Match[1]);
          } else {
            const simpleMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
            if (simpleMatch) {
              filename = simpleMatch[1].trim();
            }
          }
        }
        const blobUrl = window.URL.createObjectURL(response.body);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      },
      (err) => {
        console.error(err);
        if (err.error instanceof Blob && err.error.type.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const res = JSON.parse(reader.result as string);
              this.toastService.error(res.message || 'Không thể tải file.');
            } catch (e) {
              this.toastService.error('Không thể tải file.');
            }
          };
          reader.readAsText(err.error);
        } else {
          this.toastService.error('Không thể tải file.');
        }
      }
    );
  }

  downloadReceiptPdf(element: any) {
    if (!element || !element.id) { this.toastService.error('Không tìm thấy thông tin yêu cầu báo giá.'); return; }
    const query = element.user_id ? `?userId=${element.user_id}` : '';
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${element.id}/receipt-pdf${query}`,
      `bien-ban-bao-gia-${element.id}.pdf`
    );
  }

  downloadQuotationPdf(element: any) {
    if (!element || !element.id) { this.toastService.error('Không tìm thấy thông tin yêu cầu báo giá.'); return; }
    let query = element.user_id ? `?userId=${element.user_id}` : '';
    const voucherValue = element.vouchercode || element.voucherValue || element.voucher_value || 0;
    if (voucherValue) {
      query += (query ? '&' : '?') + `voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${element.id}/quotation-pdf${query}`,
      `chao-gia-${element.id}.pdf`
    );
  }

  downloadReceiptExcel(element: any) {
    if (!element || !element.id) { this.toastService.error('Không tìm thấy thông tin yêu cầu báo giá.'); return; }
    const query = element.user_id ? `?userId=${element.user_id}` : '';
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${element.id}/receipt-excel${query}`,
      `bien-ban-bao-gia-${element.id}.xlsx`
    );
  }

  downloadQuotationExcel(element: any) {
    if (!element || !element.id) { this.toastService.error('Không tìm thấy thông tin yêu cầu báo giá.'); return; }
    const userId = element.user_id;
    let query = userId ? `?userId=${userId}&isVat=true` : '?isVat=true';
    const voucherValue = element.vouchercode || element.voucherValue || element.voucher_value || 0;
    if (voucherValue) {
      query += `&voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${element.id}/quotation-excel${query}`,
      `chao-gia-${element.id}.xlsx`
    );
  }
downloadContractWord(element: any) {
    if (!element || !element.id) { this.toastService.error('Không tìm thấy thông tin yêu cầu báo giá.'); return; }
    let query = element.user_id ? `?userId=${element.user_id}` : '';
    const voucherValue = element.vouchercode || element.voucherValue || element.voucher_value || 0;
    if (voucherValue) {
      query += (query ? '&' : '?') + `voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${element.id}/contract-word${query}`,
      `hop-dong-${element.id}.docx`
    );
  }
}
